export default __webpack_public_path__ + "static/media/fathers-day.4de65bc5.webp";